function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { styled, useTheme } from "@mui/material";
import { Children, cloneElement, forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
function injectLinkedProp(children) {
    if (Children.count(children) > 1 || !children.type || children.type.name !== 'Card') {
        return children;
    }
    return /*#__PURE__*/ cloneElement(children, {
        isLinked: true
    });
}
var LinkStyled = styled(RouterLink)(function(props) {
    var _props_theme_palette_props_color;
    return {
        color: (_props_theme_palette_props_color = props.theme.palette[props.color]) === null || _props_theme_palette_props_color === void 0 ? void 0 : _props_theme_palette_props_color.main
    };
});
var AnchorStyled = styled('a')(function(props) {
    var _props_theme_palette_props_color;
    return {
        color: (_props_theme_palette_props_color = props.theme.palette[props.color]) === null || _props_theme_palette_props_color === void 0 ? void 0 : _props_theme_palette_props_color.main
    };
});
AnchorStyled.displayName = 'AnchorStyled';
export var Link = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var external = _param.external, to = _param.to, children = _param.children, _param_color = _param.color, color = _param_color === void 0 ? 'primary' : _param_color, variant = _param.variant, props = _object_without_properties(_param, [
        "external",
        "to",
        "children",
        "color",
        "variant"
    ]);
    var theme = useTheme();
    var isExternal = external || to && to.includes(':');
    var target = isExternal ? '_blank' : undefined; // external + URL schemes
    if (isExternal || !to) {
        return /*#__PURE__*/ _jsx(AnchorStyled, _object_spread_props(_object_spread({}, props), {
            color: color,
            "data-component": props['data-component'] || 'link',
            href: to,
            ref: ref,
            sx: theme.typography[variant],
            target: target,
            children: children
        }));
    }
    var linkedChildren = injectLinkedProp(children);
    return /*#__PURE__*/ _jsx(LinkStyled, _object_spread_props(_object_spread({}, props), {
        color: color,
        "data-component": props['data-component'] || 'link',
        ref: ref,
        sx: theme.typography[variant],
        target: target,
        to: to,
        children: linkedChildren
    }));
});
Link.displayName = 'Link';

//# sourceMappingURL=Link.js.map